module.exports = __webpack_public_path__ + "img/vest_2.0c7aae0b.png";